"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImPalette = createImPalette;
var _createPalette = _interopRequireDefault(require("@mui/material/styles/createPalette"));
var _imColors = require("./im-colors");
function createImPalette(mode) {
  var paletteOptions = {
    action: {
      disabled: _imColors.imColors.darkGrey,
      disabledBackground: _imColors.imColors.mediumGrey,
      hover: _imColors.imColors.light2Blue
    },
    attention: {
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.black800,
      light: _imColors.imColors.black50,
      main: _imColors.imColors.black
    },
    common: {
      black: _imColors.imColors.black,
      white: _imColors.imColors.white
    },
    dark: {
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.black800,
      light: _imColors.imColors.black50,
      main: _imColors.imColors.black
    },
    divider: _imColors.imColors.mediumGrey,
    error: {
      '100': _imColors.imColors.light1Red,
      '40': _imColors.imColors.lighterRed,
      '50': _imColors.imColors.light2Red,
      '600': _imColors.imColors.mediumRed,
      '700': _imColors.imColors.red,
      '900': _imColors.imColors.darkRed,
      dark: _imColors.imColors.darkRed,
      light: _imColors.imColors.light2Red,
      main: _imColors.imColors.red
    },
    grey: {
      '100': _imColors.imColors.black100,
      '200': _imColors.imColors.black200,
      '300': _imColors.imColors.black300,
      '50': _imColors.imColors.black50,
      '500': _imColors.imColors.black500,
      '600': _imColors.imColors.black600,
      '700': _imColors.imColors.black700,
      '800': _imColors.imColors.black800,
      '900': _imColors.imColors.black900,
      A100: _imColors.imColors.lightGrey,
      A200: _imColors.imColors.black260,
      A400: _imColors.imColors.black400,
      A700: _imColors.imColors.darkGrey
    },
    indigo: {
      '100': _imColors.imColors.indigo100,
      '200': _imColors.imColors.indigo200,
      '50': _imColors.imColors.indigo50,
      '600': _imColors.imColors.indigo600,
      '700': _imColors.imColors.indigo700,
      '800': _imColors.imColors.indigo800,
      '900': _imColors.imColors.indigo900,
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.indigo900,
      light: _imColors.imColors.indigo50,
      main: _imColors.imColors.indigo600
    },
    info: {
      dark: _imColors.imColors.darkBlue,
      light: _imColors.imColors.light2Blue,
      main: _imColors.imColors.blue
    },
    mode: mode,
    neutral: {
      '10': _imColors.imColors.black10,
      '100': _imColors.imColors.black100,
      '200': _imColors.imColors.black200,
      '25': _imColors.imColors.black25,
      '300': _imColors.imColors.black300,
      '35': _imColors.imColors.black35,
      '40': _imColors.imColors.black40,
      '50': _imColors.imColors.black50,
      '500': _imColors.imColors.black500,
      '600': _imColors.imColors.black600,
      '700': _imColors.imColors.black700,
      '800': _imColors.imColors.black800,
      '900': _imColors.imColors.black900,
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.black900,
      light: _imColors.imColors.black100,
      main: _imColors.imColors.black500
    },
    pink: {
      '100': _imColors.imColors.pink100,
      '50': _imColors.imColors.pink50,
      '700': _imColors.imColors.pink700,
      '800': _imColors.imColors.pink800,
      '900': _imColors.imColors.pink900,
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.pink900,
      light: _imColors.imColors.pink50,
      main: _imColors.imColors.pink700
    },
    primary: {
      '100': _imColors.imColors.light1Blue,
      '40': _imColors.imColors.lighterBlue,
      '400': _imColors.imColors.blue400,
      '50': _imColors.imColors.light50Blue,
      '500': _imColors.imColors.mediumBlue,
      '700': _imColors.imColors.blue,
      '900': _imColors.imColors.darkBlue,
      dark: _imColors.imColors.darkBlue,
      light: _imColors.imColors.light2Blue,
      main: _imColors.imColors.blue
    },
    purple: {
      '100': _imColors.imColors.purple100,
      '200': _imColors.imColors.purple200,
      '300': _imColors.imColors.purple300,
      '400': _imColors.imColors.purple400,
      '50': _imColors.imColors.purple50,
      '500': _imColors.imColors.purple500,
      '600': _imColors.imColors.purple600,
      '700': _imColors.imColors.purple700,
      '800': _imColors.imColors.purple800,
      '900': _imColors.imColors.purple900,
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.purple900,
      light: _imColors.imColors.purple100,
      main: _imColors.imColors.purple500
    },
    rose: {
      '600': _imColors.imColors.lightRose,
      '700': _imColors.imColors.rose,
      '900': _imColors.imColors.darkRose,
      contrastText: _imColors.imColors.white,
      dark: _imColors.imColors.darkRose,
      light: _imColors.imColors.lightRose,
      main: _imColors.imColors.rose
    },
    secondary: {
      dark: _imColors.imColors.darkRose,
      light: _imColors.imColors.lightRose,
      main: _imColors.imColors.rose
    },
    success: {
      '100': _imColors.imColors.mediumGreen,
      '40': _imColors.imColors.lighterGreen,
      '50': _imColors.imColors.lightGreen,
      '700': _imColors.imColors.green,
      '900': _imColors.imColors.darkGreen,
      dark: _imColors.imColors.darkGreen,
      light: _imColors.imColors.lightGreen,
      main: _imColors.imColors.green
    },
    text: {
      disabled: _imColors.imColors.mediumGrey,
      primary: _imColors.imColors.black,
      secondary: _imColors.imColors.darkGrey
    },
    warning: {
      '100': _imColors.imColors.light1Porcupine,
      '40': _imColors.imColors.lighterPorcupine,
      '50': _imColors.imColors.light2Porcupine,
      '600': _imColors.imColors.mediumPorcupine,
      '700': _imColors.imColors.porcupine,
      '900': _imColors.imColors.darkPorcupine,
      dark: _imColors.imColors.darkPorcupine,
      light: _imColors.imColors.light2Porcupine,
      main: _imColors.imColors.porcupine
    }
  };
  return (0, _createPalette["default"])(paletteOptions);
}